<template>
  <div></div>
</template>

<script>
import { getMixinAuth } from '@/api/user';
import { Toast } from 'mand-mobile';
import { mapState } from 'vuex';
export default {
  computed: mapState({
    isLogin: state => state.isLogin,
  }),
  created() {
    if (this.isLogin) {
      this.$router.replace('/exchange');
      return;
    }
    //wss 登录
    // 检查是否最近尝试过HTTP登录
    const lastLoginAttempt = window.localStorage.getItem('webLoginAttemptAt');

    // 如果最近5分钟(300000ms)内尝试过HTTP登录，直接使用WebSocket方式
    if (lastLoginAttempt && parseInt(lastLoginAttempt) > Date.now() - 300000) {
      // eslint-disable-next-line no-console
      console.log('尝试使用WebSocket方式登录');
      return this.$router.replace('/login-ws');
    }
    
    // 记录当前尝试HTTP登录的时间
    window.localStorage.setItem('webLoginAttemptAt', Date.now().toString());
    
    // 处理特殊URL路径,例如邀请码（如果需要）
    
    //增加
    getMixinAuth()
      .then(data => {
        return window.location.replace(data.data.url);
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
};
</script>
